import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Galery = ({ isUpdateGalery, setIsUpdateGalery }) => {
  const [infoVideos, setinfoVideos] = useState([]);
  const [idVideos, setIdVideos] = useState([]);
  const [arrayComplete, setArrayComplete] = useState([]);
  const navigate = useNavigate();

  const PAGE_SIZE = 6;
  const pagesCount = Math.ceil(arrayComplete.length / PAGE_SIZE);
  const [currentPage, setCurrentPage] = useState(1);
  const lastIndex = currentPage * PAGE_SIZE;
  const firstIndex = lastIndex - PAGE_SIZE;

  const [currentElements, setCurrentElements] = useState();

  const [showNewImageIndex, setShowNewImageIndex] = useState();

  const [cliked, setCliked] = useState([]);

  const fetchData = useCallback(async () => {
    await axios
      .get(`https://cloudinary-app.herokuapp.com/api/get/`)
      .then((res) => {
        setinfoVideos(res.data.ress.resources);
        return axios.get(`https://likes-count-app.herokuapp.com/likes`);
      })
      .then((res) => {
        setIdVideos(res.data.data.count_likes);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    fetchData().catch(console.error);
    setTimeout(() => {
      if (isUpdateGalery) {
        fetchData().catch(console.error);
        setIsUpdateGalery(false);
      }
    }, 10000);
    // const intervalId = setInterval(fetchData, 10000); // Actualiza cada 10 segundos
    // return () => clearInterval(intervalId);
  }, [fetchData]);

  useEffect(() => {
    combineArrays();
  }, [infoVideos, idVideos]);

  useEffect(() => {
    setCurrentElements(arrayComplete?.slice(firstIndex, lastIndex));
  }, [arrayComplete, currentPage]);

  const combineArrays = () => {
    const combinedArray = infoVideos?.map((obj1) => {
      const obj2 = idVideos.find((obj2) => obj2.id_video === obj1.asset_id);
      return obj2 ? { ...obj1, ...obj2 } : obj1;
    });

    setArrayComplete(combinedArray);
  };

  const filter = () => {
    function compareLikes(a, b) {
      return b.likes - a.likes;
    }
    arrayComplete.sort(compareLikes);
    setCurrentElements(arrayComplete?.slice(firstIndex, lastIndex));
    setCurrentPage(1);
  };

  const filterDate = () => {
    function compareLikes(a, b) {
      return new Date(b.created_at) - new Date(a.created_at);
    }
    arrayComplete.sort(compareLikes);
    setCurrentElements(arrayComplete?.slice(firstIndex, lastIndex));
    setCurrentPage(1);
  };

  const incrementLikes = async (idVideo, currentLikes) => {
    await axios.patch("https://likes-count-app.herokuapp.com/likes", {
      id_video: idVideo,
      likes: currentLikes + 1,
    });

    const updateLike = arrayComplete.map((item) => {
      if (item.asset_id === idVideo) {
        return { ...item, likes: currentLikes + 1 };
      }
      return item;
    });
    setArrayComplete(updateLike);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= pagesCount) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <div className="Galery">
      <div className="Galery_content containerAll">
        <div className="destock_galery">
          <div className="info_galery">
            <h1>Galeria</h1>
            <p>
              Un lugar especial donde puedes compartir tus propios videos y divertirte
              interactuando con los videos creados por toda la comunidad. ¡Únete y muestra
              tus videos!
            </p>

            <div className="buttons">
              <p
                onClick={() => {
                  filter();
                }}
              >
                Más populares
              </p>
              <p
                onClick={() => {
                  filterDate();
                }}
              >
                Más recientes
              </p>
            </div>
          </div>
          <div className="button_one">
            <button onClick={() => navigate("/")} crossOrigin="anonymous">
              Crear vídeo nuevo
            </button>
          </div>
        </div>

        <div className="content_galery">
          {currentElements?.map((item, i) => {
            const isClicked = cliked.includes(item.asset_id);
            return (
              <div key={i} className="galery">
                <div className="content_video">
                  <video
                    src={item.url}
                    className="video_galery"
                    crossOrigin="anonymous"
                    controls
                  ></video>

                  <div className="contet_likes">
                    <p>{item.likes}</p>
                    <div className="likes_buttons">
                      <img
                        onClick={() => {
                          if (!isClicked) {
                            setCliked([...cliked, item.asset_id]);
                            incrementLikes(item.asset_id, item.likes);
                            setShowNewImageIndex(i);
                          }
                        }}
                        src={
                          i === showNewImageIndex
                            ? "/assets/nolike.png"
                            : "/assets/nolike.png"
                        }
                        alt="gallery-image"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="pagination">
          <img
            loading="lazy"
            onClick={() => handlePageChange(currentPage - 1)}
            src="/assets/lado1.png"
            alt="flecha1"
          />

          <p>
            Pagina {currentPage} de {pagesCount}
          </p>

          <img
            loading="lazy"
            onClick={() => handlePageChange(currentPage + 1)}
            src="/assets/lado2.png"
            alt="flecha2"
          />
        </div>
      </div>
    </div>
  );
};

export default Galery;
